import {NgModule} from '@angular/core';

import {UndoQuillToolbarButtonComponent} from './index';
import {IonicModule} from 'ionic-angular';

/**
 * Module for the UndoQuillToolbarButtonModule
 * @class
 */
@NgModule({
  declarations: [UndoQuillToolbarButtonComponent],
  exports: [UndoQuillToolbarButtonComponent],
  imports: [IonicModule],
  providers: [],
})
export class UndoQuillToolbarButtonModule {
}



// WEBPACK FOOTER //
// ./src/app/content/shared/components/inputs/body/quill-toolbar/buttons/undo-quill-toolbar-button/undo-quill-toolbar-button.component.module.ts